import {LegendContent} from '../toggle/list';
import CheckIcon from '@/assets/icons/check';
import HelpCircleIcon from '@/assets/icons/help-circle';
import LayerIcon from '@/assets/icons/layer';
import ResetIcon from '@/assets/icons/map/reset';
import ZoomInIcon from '@/assets/icons/map/zoom-in';
import ZoomOutIcon from '@/assets/icons/map/zoom-out';
import {useAppDispatch, useAppSelector} from '@/hooks/redux';
import {setLayer} from '@/redux/slice/mapSlice';
import {Popover} from 'antd';
import classNames from 'classnames';
import {useEffect} from 'react';

export const LayerContent = () => {
  const dispatch = useAppDispatch();
  const layer = useAppSelector((state) => state.map.layer);
  const layers = {
    airport: false,
    weather: false,
    notam: false,
    fir: false
  };

  useEffect(() => {
    window.updateData({
      event: 'toggleNotam',
      data: layer.notam ? 'visible' : 'none'
    });
  }, [layer.notam]);

  useEffect(() => {
    window.updateData({
      event: 'toggleWeather',
      data: layer.weather ? 'visible' : 'none'
    });
  }, [layer.weather]);

  useEffect(() => {
    window.updateData({
      event: 'toggleFir',
      data: layer.fir ? 'visible' : 'none'
    });
  }, [layer.fir]);

  useEffect(() => {
    window.updateData({
      event: 'toggleAirport',
      data: layer.airport ? 'visible' : 'none'
    });
  }, [layer.airport]);

  return (
    <div className="">
      {Object.keys(layers).map((key) => (
        <div
          className="flex items-center justify-between p-lg cursor-pointer hover:opacity-80 hover:bg-[#151515] transition-all duration-150 border-b border-[#3030304D]"
          key={key}
          onClick={() => {
            dispatch(
              setLayer({
                [key]: !layer[key as keyof typeof layer]
              })
            );
          }}
        >
          <span
            className={classNames(
              'text-sm leading-sm text-[#F1F1F1] capitalize',
              {
                '!uppercase': ['pirep', 'fir'].includes(key)
              }
            )}
          >
            {key}
          </span>
          {layer[key as keyof typeof layer] && <CheckIcon />}
        </div>
      ))}
    </div>
  );
};

const ListToggle = () => {
  return (
    <div className="">
      <Popover
        content={<LayerContent />}
        overlayClassName="option-popover legend-popover"
        trigger={['click']}
        placement="right"
      >
        <div
          className={classNames(
            'shadow-md cursor-pointer rounded-[8px] bg-[#0759854D] p-[8px] hover:opacity-80 mb-[16px] border-[0.5px] border-[#0759854D]'
          )}
        >
          <LayerIcon />
        </div>
      </Popover>

      <Popover
        content={<LegendContent />}
        overlayClassName="option-popover legend-popover"
        trigger={['click']}
        placement="right"
      >
        <div
          className={classNames(
            'shadow-md cursor-pointer rounded-[8px] bg-[#0759854D] p-[8px] hover:opacity-80',
            'rounded-full border-[0.5px] border-[#0759854D]'
          )}
        >
          <HelpCircleIcon />
        </div>
      </Popover>
    </div>
  );
};

const ActionPanel = () => {
  const actionButton = [
    {
      icon: <ZoomInIcon />,
      onClick: () => {
        window.updateData({
          event: 'zoom-in'
        });
      }
    },
    {
      icon: <ZoomOutIcon />,
      onClick: () => {
        window.updateData({
          event: 'zoom-out'
        });
      }
    },
    {
      icon: <ResetIcon />,
      onClick: () => {
        window.updateData({
          event: 'camera',
          data: {
            center: [103.806241, 1.3246091],
            zoom: 4
          }
        });
      }
    }
  ];

  return (
    <div className="">
      {actionButton.map((item, index) => (
        <div
          key={index}
          className="cursor-pointer hover:opacity-80 p-md rounded-[8px] bg-[#0759854D] mb-[8px] border-[0.5px] border-[#0759854D]"
          onClick={item.onClick}
        >
          {item.icon}
        </div>
      ))}
    </div>
  );
};

const ATCSideBar = () => {
  return (
    <>
      <div className="bg-primary-dark w-[52px] py-[22px] flex flex-col items-center justify-between fixed top-[60px] left-0 z-[2] bottom-0">
        <div className="flex-grow flex flex-col items-center justify-between gap-y-[16px]">
          <ListToggle />
          <ActionPanel />
        </div>
      </div>
    </>
  );
};

export default ATCSideBar;
